var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.695,
    height: 21.468,
    viewBox: "0 0 10.695 21.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M43.879,23.128h-2.46c-.4,0-.519-.165-.519-.561V19.317c0-.429.153-.594.519-.594h2.46v-2.36a6.371,6.371,0,0,1,.672-3.036,4.233,4.233,0,0,1,2.215-1.98A5.013,5.013,0,0,1,48.662,11h2.429c.351,0,.5.165.5.545V14.6c0,.38-.153.545-.5.545-.672,0-1.345,0-2.017.033s-1.024.347-1.024,1.106c-.031.809,0,1.584,0,2.409h2.857c.4,0,.55.165.55.594v3.251c0,.429-.122.594-.55.594H48.081v8.729c0,.462-.153.611-.565.611h-3.1c-.367,0-.519-.165-.519-.561Z",
    transform: "translate(-40.9 -11)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.0b4338b7e1d715e609a419755cfec5b5.svg";
export { ForwardRef as ReactComponent };